import { UserChatItem } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import styled from 'styled-components/native';
import Shadow from '../../components/Shadow';

type Props = {
  item: UserChatItem;
};

export function ChatUserTextItem(props: Props) {
  const { item } = props;

  return (
    <Container>
      <ChatText color="white">{item.text}</ChatText>
    </Container>
  );
}

const Container = styled(Shadow)`
  padding: 12px;
  margin-bottom: 12px;
  max-width: 80%;
  background-color: ${colors.primary[70]};
  margin-left: auto;
  border-radius: 10px;
  border-top-right-radius: 0;
`;

const ChatText = styled(Text)`
  color: white;
  font-size: 24px;
`;
